import PropTypes from 'prop-types'
import React, { useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaUpload} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"



const DandiButton = ({sessionID, color, loadStatus }) => {
  const [buttonState, changeButtonState] = useState(true)
  const buttonClick = () => {
    changeButtonState(updateStatus())    
  }

  const project = useDrop().currentDrop

  const updateStatus = async () => {
    const res = await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/' + project + "/" + sessionID + '/' + 'upload',{
        method: 'POST',
    })
    const res2 =  await fetch('https://us-central1-openscopedataback.cloudfunctions.net/app/api/table/status/' + project
                              + '/' + sessionID)
    const data = await res2.json()
    console.log(data)
    loadStatus(data, sessionID)
    return data
  }
 
  return (
    <button
      onClick={buttonClick}
      id={sessionID + "dandi"}
      style={{
        backgroundColor: color,
        width: '40px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      className='btn'
      data-tooltip-content="Upload to dandi"
    >
      <div style={{ justifyContent: "center" }}>
        <FaUpload />
        <ReactTooltip anchorId={sessionID + 'dandi'} />
      </div>
    </button>
  );
}


DandiButton.defaultProps = {
  color: 'steelblue',
  sessionID: 837360280,
}

DandiButton.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default DandiButton